import { EntitiesListView } from 'components/eventView/entities/EntitiesListView';
import { EntitiesSectionView } from 'components/eventView/entities/EntitiesSectionView';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';

interface Props {
    entityId: string;
    className?: string;
    align?: 'left' | 'center';
}

export const EVOtherEntitiesPageContent = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);

    const settings = ctxEventView.eventData.listViewSettings?.[props.entityId];

    if (settings?.viewType === 'sections') {
        return <EntitiesSectionView entityId={props.entityId} className={props.className} />;
    }

    return (
        <EntitiesListView
            entityId={props.entityId}
            className={props.className}
            align={props.align}
        />
    );
};
